module.exports = __webpack_public_path__ + "media/images/redeem_bar_background-84628c36a6761755b6ca6c9389b5b361.png";